export default __webpack_public_path__ + "static/media/instagram.68d44f61.png";